// src/flow/CreateFlowContext.jsx
// Where the user is in the left-column flow (answers, confirmed steps, media choices).
// Lives above both the desktop and the mobile layouts, so they share one state and it
// survives a mobile screen being rebuilt.
import { createContext, useContext, useState } from "react";
import {
  CAROUSEL_DEFAULT_DESIGN,
  CAROUSEL_DEFAULT_LOGO_REL,
} from "./carouselDefaults";

const CreateFlowContext = createContext(null);

export function CreateFlowProvider({ children, videoUpload }) {
  const [ownTextAnswer, setOwnTextAnswer] = useState(null);       // true | false | null
  const [showPostIdeas, setShowPostIdeas] = useState(false);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [pdfError, setPdfError] = useState(null);
  const [ideasConfirmed, setIdeasConfirmed] = useState(false);
  const [mediaConfirmed, setMediaConfirmed] = useState(false);
  const [mediaTypeConfirmed, setMediaTypeConfirmed] = useState(false);
  const [mediaSource, setMediaSource] = useState(null);           // "have" | "need"
  const [imageFormat, setImageFormat] = useState(null);           // "square" | "infographic" | "rectangle"
  const [askImageFormat, setAskImageFormat] = useState(false);
  const [askBrandColors, setAskBrandColors] = useState(false);
  const [brandThemeId, setBrandThemeId] = useState(null);
  const [carouselCreated, setCarouselCreated] = useState(false);
  const [carouselDesign, setCarouselDesign] = useState(CAROUSEL_DEFAULT_DESIGN);
  const [carouselLogo, setCarouselLogo] = useState(null);
  const [carouselLogoRel, setCarouselLogoRel] = useState(CAROUSEL_DEFAULT_LOGO_REL);

  const value = {
    ownTextAnswer, setOwnTextAnswer,
    showPostIdeas, setShowPostIdeas,
    pdfFiles, setPdfFiles,
    pdfError, setPdfError,
    ideasConfirmed, setIdeasConfirmed,
    mediaConfirmed, setMediaConfirmed,
    mediaTypeConfirmed, setMediaTypeConfirmed,
    mediaSource, setMediaSource,
    imageFormat, setImageFormat,
    askImageFormat, setAskImageFormat,
    askBrandColors, setAskBrandColors,
    brandThemeId, setBrandThemeId,
    carouselCreated, setCarouselCreated,
    carouselDesign, setCarouselDesign,
    carouselLogo, setCarouselLogo,
    carouselLogoRel, setCarouselLogoRel,
    videoUpload, // NEW
  };

  return <CreateFlowContext.Provider value={value}>{children}</CreateFlowContext.Provider>;
}

export function useCreateFlow() {
  const ctx = useContext(CreateFlowContext);
  if (!ctx) throw new Error("useCreateFlow must be used inside <CreateFlowProvider>");
  return ctx;
}